import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface Message {
    type: string;
    payload: any;
}

type MessageCallback = (payload: any) => void;

@Injectable()
/**
 * type :
 * pickResult : 게임결과 수신
 * scroll : 화면 스크롤
 * chancetalk : 화면 하단 찬스톡
 * popup : 팝업
 */
export class EventService {
    private handler = new Subject<Message>();
    // this.eventService.brodcast
    broadcast(type: string, payload: any) {

        this.handler.next({ type, payload });

        // payload : {type: popup, component: ddddd, params: {}}
        // {    type: 'chatroomView',room_id: roomid};
        // {type: 'pickResult', data: req}
    }

    // this.eventService.subscribe
    subscribe(type: string, callback: MessageCallback): Subscription {
//        return this.handler
//        .subscribe(callback);

        return this.handler
        .pipe(filter(message => message.type === type))
        .pipe(map(message => message.payload))
        .subscribe(callback);
    }
}
